module.exports = __webpack_public_path__ + "static/media/competitive.b56adce8.jpg";